export default "__VITE_ASSET__b_CaEN$z__"